<ws-loading-indicator
  *ngIf="isLoading"
  class="d-flex justify-content-center align-items-center"
  style="height: 8vh"
></ws-loading-indicator>
<main *ngIf="!isLoading">
    <app-page-header [title]="'Exports'"></app-page-header>
    
    <div class="row mt-5"> <i>Pick an end date for the work week and export the timesheets from that week to an Excel.</i></div>
    <div [formGroup]="exportSearchForm" class="row mt-5">
        <div class="col">
       
          <select class="form-control" formControlName="userId">
            <option value="showAllProviders">Show All</option>
            <option *ngFor="let provider of providers" [value]="provider.userId">
              {{ provider.name }}
            </option>
          </select>
        </div>
          <div class="col">
            <div class="form-group">
              <select class="form-control" formControlName="weekEndDate"
                      (change)="changeWeekEndDate($event)">
                <option *ngFor="let weekEndDate of weekEndDates"
                        value="{{ weekEndDate }}">
                  {{ weekEndDate }}
                </option>
              </select>
            </div>
          </div>
          <div class="col">
            <app-button
              buttonText="Export Summary"
              buttonColor="success"
              class="ms-2"
              (onClickedEvent)="exportTimesheet()"
            ></app-button>
          </div>
        </div>
      <div class="row mt-5">
        <ws-wssync-fusion-grid
          [accessToken]="accessToken"
          [dataSourceEndpoint]="'ExportOD'"
          [gridNameForColumns]="'TimesheetSummaryV1Model'"
          [query]="query"
          [showCommands]="true"
          [commands]="commands"
          [toolbarOptions]="toolbarOptions"
        >
        </ws-wssync-fusion-grid>
      </div>
    </main>

